import { Disorder } from '../types';

/**
 * Datos de trastornos que trata Conectemos Chile
 */
export const disorders: Disorder[] = [
  {
    id: 'ansiedad',
    icon: 'fas fa-brain',
    title: 'Trastornos de Ansiedad',
    description: 'Ansiedad generalizada, ataques de pánico, fobias específicas, trastorno obsesivo-compulsivo (TOC), estrés postraumático, ansiedad social.'
  },
  {
    id: 'estado-animo',
    icon: 'fas fa-cloud-rain',
    title: 'Trastornos del Estado de Ánimo',
    description: 'Depresión mayor, distimia, trastorno bipolar, ciclotimia, trastornos adaptativos con estado de ánimo depresivo, depresión posparto.'
  },
  {
    id: 'pareja-familia',
    icon: 'fas fa-users',
    title: 'Problemas de Pareja y Familia',
    description: 'Conflictos de comunicación, infidelidad, crisis de pareja, problemas en la crianza, divorcios, familias reconstituidas, mediación familiar.'
  },
  {
    id: 'sueno',
    icon: 'fas fa-moon',
    title: 'Trastornos del Sueño',
    description: 'Insomnio, hipersomnia, pesadillas recurrentes, trastornos del ritmo circadiano, problemas de conciliación del sueño, apnea del sueño.'
  },
  {
    id: 'autoestima',
    icon: 'fas fa-heart',
    title: 'Autoestima y Desarrollo Personal',
    description: 'Inseguridad, baja autoestima, falta de habilidades sociales, asertividad, crecimiento personal, mindfulness, inteligencia emocional.'
  },
  {
    id: 'estres-laboral',
    icon: 'fas fa-briefcase',
    title: 'Estrés Laboral',
    description: 'Burnout, adaptación a cambios laborales, conflictos en el trabajo, gestión del estrés, desarrollo de carrera, equilibrio vida-trabajo.'
  },
  {
    id: 'trauma-duelo',
    icon: 'fas fa-hand-holding-heart',
    title: 'Trauma y Duelo',
    description: 'Procesamiento de experiencias traumáticas, duelo por pérdidas significativas, EMDR, terapia de exposición, resiliencia, superación.'
  },
  {
    id: 'personalidad',
    icon: 'fas fa-puzzle-piece',
    title: 'Trastornos de la Personalidad',
    description: 'Trastorno límite, narcisista, evitativo, dependiente, obsesivo-compulsivo, histriónico y otras alteraciones de la personalidad.'
  }
];